import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

export const CallSummaryMarkdown = ({ text }: { text: string }) => {
  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        h2({ children }) {
          return (
            <h2 className="t-text-subtitle-lg t-text-text-100 t-mb-2 t-mt-4 first:t-mt-0">
              {children}
            </h2>
          );
        },
        h3({ children }) {
          return (
            <h3 className="t-text-subtext t-font-semibold t-text-text-100 t-mb-1 t-mt-3">
              {children}
            </h3>
          );
        },
        p({ children }) {
          return (
            <p className="t-text-body t-text-text-30 t-mb-2 last:t-mb-0">
              {children}
            </p>
          );
        },
        strong({ children }) {
          return <strong className="t-font-semibold">{children}</strong>;
        },
        ul({ children }) {
          return (
            <ul className="t-list-disc t-pl-4 t-text-body t-text-text-30">
              {children}
            </ul>
          );
        },
        li({ children }) {
          return <li className="t-mb-1 last:t-mb-0">{children}</li>;
        },
      }}
    >
      {text}
    </ReactMarkdown>
  );
};
